import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomDropdownWithSelect } from '../DropDown/CustomDropdown';

const OrderToBeVerifiedFilter = ({
  orderVerifiedList,
  selectedVerified,
  setSelectedVerified,
  handleClick,
  handleClose,
  anchorEl,
}) => {
  const { t } = useTranslation();
  const [isDropdownOpenVerified, setIsDropdownOpenVerified] = useState(false);

  const handleButtonClick = (event) => {
    setIsDropdownOpenVerified(true);
    handleClick('-1', event);
  };

  const handleDropdownClose = () => {
    setIsDropdownOpenVerified(false);
    handleClose('-1');
  };

  return (
    <>
      <button
        aria-controls="customized-menu"
        aria-haspopup="true"
        onClick={handleButtonClick}
        style={{
          padding: '5px',
          border: 'none',
          background: 'none',
        }}
      >
        {selectedVerified.text !== 'Tous les types' ? (
          <img
            style={{
              width: '25px',
              height: '25px',
            }}
            src="/Images/icon-filter-hover.png"
            alt="filter"
          />
        ) : (
          <img src="/Images/icon-filter.png" alt="filter" />
        )}
      </button>
      <CustomDropdownWithSelect
        value={selectedVerified}
        handleClose={handleDropdownClose}
        anchorEl={anchorEl && anchorEl['-1']}
        list={orderVerifiedList}
        setValue={(index) => setSelectedVerified(orderVerifiedList[index])}
        getOptionLabel={(option) => {
          return t(option.text);
        }}
        open={setIsDropdownOpenVerified}
      />
    </>
  );
};

export default OrderToBeVerifiedFilter;
